module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABFElEQVQ4jaXTzypFURTH8c/VnRkgFIoy9icG/sxQJgxNxFTduSjewgN4ARkp5QmEoT8PoCTUxYwBhZb2rdPtnuPmrtHZe6/z3Xv91m+VKpWKgujAFM7xlpdWLgB04QrdeMAsXholthVAFtPtAbvHdl5iEaQHz/jAMUb/A2nP6DCAp7zEPE1KWMZZWs/jFvVdeMRJOfNTZ/oODXYxgtW0d4fhBpAhHNUgF5jOHJ5iDtW0Xsl58QIOy8kLAZjEOgaxlld/XfRH57LCRs2v+GoSEDGBy6LuNBNjuGkVMh6ubgXSm/xz3QokSgmfVFuBhKgxoL+O/cQ3NjGDPuz8AYjLN7Bfg7xjC0vJuTF0McFFETY4wB78ABy9LuXpHM5bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dianzan.png
// module id = PX/M
// module chunks = 1